import {
  permitTemplatesKeys,
  RequestTypes,
} from '@core/react-query/features/templates/permitTemplates'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  IPermitTemplate,
  PermitTemplate,
} from '@core/entities/permit/PermitTemplate'

const dataTransformer = (response: IPermitTemplate[]) =>
  response.map((template) => PermitTemplate.new(template))

export const useGetPermitTemplateFilterList = (
  payload: RequestTypes['getPermitTemplateFilterList'],
  options?: UseQueryOptions<IPermitTemplate[], string, PermitTemplate[]>,
) => {
  return useQuery({
    select: dataTransformer,
    ...permitTemplatesKeys.filterList(payload),
    ...options,
  })
}
